"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReportTemplateShortcut = instanceOfReportTemplateShortcut;
exports.ReportTemplateShortcutFromJSON = ReportTemplateShortcutFromJSON;
exports.ReportTemplateShortcutFromJSONTyped = ReportTemplateShortcutFromJSONTyped;
exports.ReportTemplateShortcutToJSON = ReportTemplateShortcutToJSON;
/**
 * Check if a given object implements the ReportTemplateShortcut interface.
 */
function instanceOfReportTemplateShortcut(value) {
    if (!('content' in value) || value['content'] === undefined)
        return false;
    if (!('created_at' in value) || value['created_at'] === undefined)
        return false;
    if (!('deleted_at' in value) || value['deleted_at'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('report_template_id' in value) || value['report_template_id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined)
        return false;
    return true;
}
function ReportTemplateShortcutFromJSON(json) {
    return ReportTemplateShortcutFromJSONTyped(json, false);
}
function ReportTemplateShortcutFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'content': json['content'],
        'created_at': json['created_at'],
        'deleted_at': json['deleted_at'],
        'id': json['id'],
        'report_template_id': json['report_template_id'],
        'title': json['title'],
        'updated_at': json['updated_at'],
    };
}
function ReportTemplateShortcutToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'content': value['content'],
        'created_at': value['created_at'],
        'deleted_at': value['deleted_at'],
        'id': value['id'],
        'report_template_id': value['report_template_id'],
        'title': value['title'],
        'updated_at': value['updated_at'],
    };
}
